import { selector } from 'recoil'
import faqAtom from './faq.atom'
import { IFaqCategory } from './faq.types'

const faqCategoriesMap = selector({
  key: 'selectors/faq-categories-map',
  get: ({ get }): Record<IFaqCategory['id'], IFaqCategory> => {
    const state = get(faqAtom)

    return state.categories.reduce((acc, val) => ({ ...acc, [val.id]: val }), {})
  },
})

const faqSelectors = { faqCategoriesMap }
export default faqSelectors
